/** Serialize state reads without dropping a notification received during an in-flight read. */
export function createEntryStateRefresh<T>(
  read: () => Promise<T>,
  apply: (value: T) => void,
  onError: (error: unknown) => void,
) {
  let active = true;
  let busy = false;
  let again = false;
  const refresh = async (): Promise<void> => {
    if (!active) return;
    if (busy) {
      again = true;
      return;
    }
    busy = true;
    try {
      do {
        again = false;
        try {
          const value = await read();
          if (active) apply(value);
        } catch (error) {
          if (active) onError(error);
        }
      } while (active && again);
    } finally {
      busy = false;
    }
  };
  return {
    refresh,
    dispose: () => {
      active = false;
      again = false;
    },
  };
}
